/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Read_Along_Ai_EstimateInputs */

const en_read_along_ai_estimate = /** @type {(inputs: Read_Along_Ai_EstimateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.seconds} seconds remaining. This estimate updates as sections finish.`)
};

const es_read_along_ai_estimate = /** @type {(inputs: Read_Along_Ai_EstimateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quedan unos ${i?.seconds} segundos. La estimación se actualiza al completar las secciones.`)
};

/**
* | output |
* | --- |
* | "About {seconds} seconds remaining. This estimate updates as sections finish." |
*
* @param {Read_Along_Ai_EstimateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_estimate = /** @type {((inputs: Read_Along_Ai_EstimateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_EstimateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_estimate(inputs)
	return en_read_along_ai_estimate(inputs)
});